import { BottleService, GuestList, Ticket } from '@domain/admission';
import { formatCurrency } from '@utils/price-formatter/price-formatter';

export const getAfterOfferDescriptionFromAdmission = ({ offer }: { offer: BottleService | GuestList | Ticket }) => {
  const priceDisplay = formatCurrency({
    currency: offer.price.currency,
    number: offer.price.amount,
  });
  return `${offer.displayName} - ${priceDisplay}${offer.displayDescription ? ` - ${offer.displayDescription}` : ''}`;
};
